import { useContrastMutation } from '../../../hooks/use-contrast-mutation'
import { UseMutationOptions } from 'react-query'
import {
  PostFreeTrialActivationArgs,
  PostFreeTrialActivationResponse,
  postFreeTrialActivation
} from '../../../api/mutations/free-trial/post-free-trial-activation'
import { HTTPError } from '../../../api/fetch/decorate-fetch'

export function usePostFreeTrialActivation(
  options?: UseMutationOptions<
    PostFreeTrialActivationResponse,
    Error,
    PostFreeTrialActivationArgs
  >
) {
  return useContrastMutation<
    PostFreeTrialActivationResponse,
    HTTPError,
    PostFreeTrialActivationArgs
  >(postFreeTrialActivation, options)
}
